import React from 'react';

import moment from 'moment';

export default function SupplierContractTermNotesTable(props) {
    return (
        <div className="tw-relative tw-overflow-hidden tw-border-2 tw-border-grey tw-rounded-lg tw-text-charcoal tw-text-sm">
            <table className="tw-w-full tw-table-auto tw-border-collapse tw-text-left">
                <thead className="tw-bg-blue-25 tw-font-semibold tw-capitalize">
                    <tr>
                        <th className="tw-p-4">{$t('note')}</th>
                        <th className="tw-p-4">{$t('by')}</th>
                        <th className="tw-p-4">{$t('Created at')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!props.notes?.length ? (
                        <tbody>
                            <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
                                <td colSpan="100" className="tw-p-4">
                                    <span>{$t('This contract has no notes')}</span>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {props.notes.map((note) => (
                                <NoteRow key={note.id} note={note} />
                            ))}
                        </tbody>
                    )}
                </tbody>
            </table>
        </div>
    );
}

function NoteRow({ note }) {
    return (
        <tr className="tw-border-b-2 last:tw-border-0 tw-border-grey tw-bg-grey/50">
            <td className="tw-p-4 tw-border-r-2">{note.content}</td>
            <td className="tw-p-4 tw-border-r-2">{`${note.user.first_name} ${note.user.last_name}`}</td>
            <td className="tw-p-4">{moment(note.created_at).format('YYYY-MM-DD')}</td>
        </tr>
    );
}
